<template>
  <div class="game-cotrol-panel-button" :class="[{ 'disable-check': blockCheckAction }]" @click="dispatchEvent()">
    <div class="check-game transition-container" v-if="name === 'checkButton'">
      <div class="control-panel-button-image check-game-disabled" v-if="disabled || blockCheckAction"></div>
      <div class="control-panel-button-image check-game-active active" v-if="!disabled && !blockCheckAction"></div>
      <div class="control-panel-button-image check-game-inactive inactive" v-if="!disabled && !blockCheckAction"></div>
    </div>
    <div class="resolve-button transition-container" v-if="name === 'resolveButton'">
      <div class="control-panel-button-image resolve-button-disabled" v-if="disabled || blockCheckAction"></div>
      <div class="control-panel-button-image resolve-button-active active" v-if="!disabled && !blockCheckAction"></div>
      <div
        class="control-panel-button-image resolve-button-inactive inactive"
        v-if="!disabled && !blockCheckAction"
      ></div>
    </div>
    <div class="reset-button transition-container" v-if="name === 'resetButton'">
      <div class="control-panel-button-image reset-button-disabled" v-if="disabled || blockCheckAction"></div>
      <div class="control-panel-button-image reset-button-active active" v-if="!disabled && !blockCheckAction"></div>
      <div
        class="control-panel-button-image reset-button-inactive inactive"
        v-if="!disabled && !blockCheckAction"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'tr-game-control-panel-button-v2',
  props: {
    name: {
      type: null,
      default: '',
    },
    disabled: {
      type: null,
      default: false,
    },
  },
  mounted: function () {},
  methods: {
    throttled: _.throttle((context) => {
      context.$emit('eventType');
    }, 1100),
    dispatchEvent() {
      this.throttled(this);
    },
    // dispatchEvent() {
    //   // console.log('this', this);
    // }
  },
  computed: {
    blockCheckAction() {
      return this.$store.getters.blockCheckAction && this.name === 'checkButton';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';

.game-cotrol-panel-button {
  display: flex;
  text-align: center;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 30px;
  color: $firstIconColor;
  .transition-container {
    position: relative;
    width: 64px;
    height: 64px;
  }
  .control-panel-button-image {
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .check-game-active {
    background-image: url('~@/assets/icons/book/gameInterface/checkGameInActive.png');
  }
  .check-game-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/checkGameActive.png');
  }
  .check-game-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_SPRAWDZ_nieaktywny.png');
  }
  .resolve-button-active {
    background-image: url('~@/assets/icons/book/gameInterface/showInCorrectActive.png');
  }
  .resolve-button-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/showCorrectActive.png');
  }
  .resolve-button-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_KEY_nieaktywny.png');
  }
  .reset-button-active {
    background-image: url('~@/assets/icons/book/gameInterface/resetInActive.png');
  }
  .reset-button-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/resetActive.png');
  }
  .reset-button-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_RESET_nieaktywny.png');
  }

  .inactive {
    opacity: 0;
    &:hover {
      transition: opacity 0.3s ease-in-out;
      opacity: 1;
    }
  }
}
.disable-check {
  pointer-events: none;
  opacity: 0.5;
}
</style>
